import * as types from "./mutation-type";
import { API_STATES } from "@/helpers";

const mutations = {
  [types.GET_ALERTS_BEGIN](state) {
    state.alertsGetState = API_STATES.REQUEST_PENDING;
  },
  [types.GET_ALERTS_SUCCESS](state, alerts) {
    state.alertsGetError = null;
    state.alerts = alerts;
    state.alertsGetState = API_STATES.REQUEST_SUCCESS;
  },
  [types.GET_ALERTS_ERROR](state, err) {
    state.alertsGetState = API_STATES.REQUEST_ERROR;
    state.alertsGetError = err;
  },

  [types.DELETE_ALERT_BEGIN](state) {
    state.alertDeleteState = API_STATES.REQUEST_PENDING;
  },
  [types.DELETE_ALERT_SUCCESS](state) {
    state.alertDeleteError = null;
    state.alertDeleteState = API_STATES.REQUEST_SUCCESS;
  },
  [types.DELETE_ALERT_ERROR](state, err) {
    state.alertDeleteState = API_STATES.REQUEST_ERROR;
    state.alertDeleteError = err;
  },


  [types.CREATE_ALERT_BEGIN](state) {
    state.alertCreateState = API_STATES.REQUEST_PENDING
  },
  [types.CREATE_ALERT_SUCCESS](state, data) {
    state.alert = data;
    state.alertCreateError = null;
    state.alertCreateState = API_STATES.REQUEST_SUCCESS
  },
  [types.CREATE_ALERT_ERROR](state, err) {
    state.alertCreateState = API_STATES.REQUEST_ERROR;
    state.alertCreateError = err;
  },

  [types.UPDATE_ALERT_BEGIN](state) {
    state.alertUpdateState = API_STATES.REQUEST_PENDING
  },
  [types.UPDATE_ALERT_SUCCESS](state, data) {
    state.alertUpdateError = null
    state.alert = data
    state.alertUpdateState = API_STATES.REQUEST_SUCCESS
  },
  [types.UPDATE_ALERT_ERROR](state, err) {
    state.alertUpdateState = API_STATES.REQUEST_ERROR
    state.alertUpdateError = err
  },
};

export default mutations;
